export function getThemedClassName(name: string, isDarkTheme: boolean): string {
    return isDarkTheme ? name + '-dark ' + name : name;
}

export function getThemedClassNameAlt(name: string, isDarkTheme: boolean, darkThemeName: string): string {
    return isDarkTheme ? darkThemeName : name;
}
